// Time helpers shared by the subtitle-free annotation form and its list.

// Step (seconds) for the +/- time buttons.
export const TIME_STEP = 0.5;

export const round = (t) => Math.round(t * 10) / 10;

/**
 * A time typed by the teacher: "1:03.7", "0:03.7", "3.7" or "3,7" (seconds),
 * to tenths of a second. Null if it isn't a time.
 */
export const parseTime = (text) => {
  const m = /^\s*(?:(\d+):)?(\d+(?:[.,]\d*)?|[.,]\d+)\s*$/.exec(text || '');
  if (!m) return null;
  return round((m[1] ? Number(m[1]) * 60 : 0) + Number(m[2].replace(',', '.')));
};

/**
 * Show the video at t, paused: what tapping a subtitle or word in the
 * annotate page's lists does (MediaPlayer's showAt), else a plain seek.
 */
export const showVideoAt = (t) => {
  if (window.__hojaVideoShowAt) window.__hojaVideoShowAt(t);
  else if (window.__hojaVideoSeekTo) window.__hojaVideoSeekTo(t);
};

// 42.3 → "0:42.3"
export const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = (seconds % 60).toFixed(1);
  return `${m}:${s.padStart(4, '0')}`;
};
